import React from "react";
import { Check, MoveRight, PhoneCall } from "lucide-react";
import { Badge } from "./ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { plans } from "../data/mockData";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../lib/utils";

const PricingCards = () => {
  const { selectedPlan, setPlan } = useCart();

  return (
    <div className="w-full py-20 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex text-center justify-center items-center gap-4 flex-col">
          <Badge>Planes</Badge>
          <div className="flex gap-2 flex-col">
            <h2 className="text-3xl md:text-5xl tracking-tighter max-w-xl text-center font-regular">
              Planes de suscripción para empresas
            </h2>
            <p className="text-lg leading-relaxed tracking-tight text-muted-foreground max-w-xl text-center">
              Mantené tus equipos siempre en perfecto estado.
            </p>
          </div>
          <div className="grid pt-12 text-left grid-cols-1 lg:grid-cols-3 w-full gap-8">
            {plans.map((plan, index) => (
              <Card
                key={plan.id}
                className={`plan-card w-full ${plan.popular ? "shadow-2xl" : ""}`}
              >
                <CardHeader>
                  <CardTitle>
                    <span className="flex flex-row gap-4 items-center font-normal">
                      {plan.name}
                    </span>
                  </CardTitle>
                  <CardDescription>{plan.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-col gap-8 justify-start">
                    <p className="flex flex-row items-center gap-2 text-xl">
                      <span className="text-4xl">{formatPrice(plan.price)}</span>
                      <span className="text-sm text-muted-foreground">/ mes por equipo</span>
                    </p>
                    <div className="flex flex-col gap-4 justify-start">
                      {plan.features.map((feature) => (
                        <div key={feature} className="flex flex-row gap-4">
                          <Check className="w-4 h-4 mt-2 text-primary" />
                          <div className="flex flex-col">
                            <p>{feature}</p>
                            <p className="text-muted-foreground text-sm">
                              Beneficio incluido en el plan.
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <Button
                      variant={plan.popular ? "default" : "outline"}
                      className="gap-4"
                      onClick={() => setPlan(plan)}
                    >
                      {selectedPlan && selectedPlan.id === plan.id ? "Seleccionado" : "Seleccionar"}
                      {index === 2 ? <PhoneCall className="w-4 h-4" /> : <MoveRight className="w-4 h-4" />}
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingCards;
